export const SCROLL_THRESHOLD = 200;
export const TOAST_VISIBILITY_CHECK_INTERVAL = 1000;
